// extracted by mini-css-extract-plugin
export var wordcloud = "wordcloud-module--wordcloud--iTPsQ";
export var a = "wordcloud-module--a--Ara0B";
export var deleted = "wordcloud-module--deleted--ORSrW";
export var b = "wordcloud-module--b--iEOvu";